module.exports = __webpack_public_path__ + "img/4_165.d5b8ea00.png";